<template>
  <div>
    <b-overlay
      :show="isLoading"
      rounded="sm"
      spinner-variant="primary"
      opacity="0.8"
      variant="primary-light"
      style="height: 100%"
    >
      <div class="p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
        <div class="row d-flex align-items-center" style="max-width: 1000px">
          <div class="col">
            <div>
              <h4>
                <b-icon class="me-2" icon="file-earmark"></b-icon>
                {{ $route.params.aid ? 'Nachtrag' + (editMode ? ' bearbeiten' : '') : 'Nachtrag erfassen' }}
              </h4>
            </div>
          </div>
          <div class="col-auto">
            <div class="form-inline">
              <!---------------------------------
                HEADER ACTION BUTTONS
            ---------------------------------->

              <b-button
                variant="secondary"
                class="ml-2"
                @click="saveRecordAndReturn"
                v-show="editMode && ($root.$user.isPlaner || $root.$user.isAdmin)"
                :disabled="!recordFormChanged"
              >
                <b-icon icon="pencil" variant="white" class="mr-1"></b-icon>
                Nachtrag speichern
              </b-button>
              <!--
              <b-button class="ml-2" variant="white" @click="$router.go(-1)" v-show="editMode">
                <b-icon icon="x" variant="dark" class="mr-1"></b-icon>
                Abbrechen
              </b-button> -->

              <b-button
                v-if="
                  !editMode &&
                    this.$route.params &&
                    typeof this.$route.params.aid !== 'undefined' &&
                    ($root.$user.isPlaner || $root.$user.isAdmin)
                "
                class="ml-2"
                variant="white"
                @click="editMode = !editMode"
              >
                <b-icon icon="lock" variant="dark" class="" style="padding-top: 1px"></b-icon>
              </b-button>

              <b-button
                v-if="editMode && this.$route.params && typeof this.$route.params.aid !== 'undefined'"
                class="ml-2"
                variant="white"
                @click="editMode = !editMode"
              >
                <b-icon icon="unlock" variant="dark" class="" style="padding-top: 1px"></b-icon>
              </b-button>
              <b-button class="ml-2" variant="white" @click="$router.go(-1)">
                <b-icon icon="x" variant="dark"></b-icon>
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div class="main-canvas bg-primary-light" style="height: calc(100vh - 476px); overflow-y: auto">
        <b-form ref="recordForm" id="recordForm">
          <div class="row" style="max-width: 1000px">
            <div class="col col-4">
              <label class="text-muted d-block mb-1"><small>Nummer</small></label>
              <b-input
                v-model="record.Nr"
                ref="numberField"
                @keyup="onFormFieldKeyUp"
                required
                :disabled="!editMode"
                maxlength="50"
                autofocus
              />
            </div>
            <div class="col col-8">
              <label class="text-muted d-block mb-1"><small>Inhalt</small></label>
              <b-input
                v-model="record.Inhalt"
                @keyup="onFormFieldKeyUp"
                required
                :disabled="!editMode"
                maxlength="100"
              />
            </div>
          </div>
          <div class="row mt-2" style="max-width: 1000px">
            <div class="col col-4">
              <label class="text-muted d-block mb-1"><small>Nachtragshöhe</small></label>
              <b-input-group prepend="€" :disabled="!editMode">
                <b-input
                  v-model="record.NHoehe"
                  @keyup="onFormFieldKeyUp"
                  :disabled="!editMode"
                  type="number"
                  step="0.01"
                />
              </b-input-group>
            </div>
            <div class="col col-4">
              <label class="text-muted d-block mb-1"><small>Nachtragsdatum</small></label>
              <b-input
                v-model="record.NDate"
                ref="numberField"
                @keyup="onFormFieldKeyUp"
                type="date"
                :required="record.NHoehe > 0"
                :disabled="!editMode"
              />
            </div>
            <div class="col col-4">
              <label class="text-muted d-block mb-1"><small>Eingangsdatum</small></label>
              <b-input
                v-model="record.EDate"
                @keyup="onFormFieldKeyUp"
                type="date"
                :required="record.NHoehe > 0"
                :disabled="!editMode"
              />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col" style="max-width: 1000px">
              <h5 class="mt-3">Prüfung</h5>
              <hr class="mt-0" />
            </div>
          </div>
          <div class="row" style="max-width: 1000px">
            <div class="col col-4">
              <div class="row">
                <div class="col-8">
                  <label class="text-muted d-block mb-1 text-nowrap"><small>Nachtragshöhe (geprüft)</small></label>
                  <b-input-group
                    prepend="€"
                    :disabled="record.Status !== '0' || !editMode"
                    :readonly="record.Status !== '0'"
                  >
                    <b-input
                      v-model="record.NHoeheChecked"
                      @change="
                        recordFormChanged = true;
                        takeOverAHoehe();
                      "
                      type="number"
                      step="0.01"
                      :disabled="record.Status !== '0' || !editMode"
                      :readonly="record.Status !== '0'"
                    />
                  </b-input-group>
                </div>
                <div class="col col-4 pl-0">
                  <b-form-checkbox
                    style="padding-top: 31px"
                    class="text-nowrap"
                    id="checkbox-1"
                    v-model="record.Status"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0"
                    @change="onCheckBoxAbgelehntChange"
                    :disabled="!editMode"
                  >
                    <small>abgelehnt</small>
                  </b-form-checkbox>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <label class="text-muted d-block mb-1"><small>Prüfdatum</small></label>
                  <b-input
                    v-model="record.PDate"
                    @change="
                      recordFormChanged = true;
                      takeOverAHoehe();
                    "
                    type="date"
                    :required="record.NHoeheChecked > 0"
                    :disabled="!editMode"
                  />
                </div>
              </div>
            </div>

            <div class="col">
              <label class="text-muted d-block mb-1"><small>Kommentar</small></label>
              <b-form-textarea
                rows="3"
                max-rows="3"
                v-model="record.Comment"
                @keyup="onFormFieldKeyUp"
                type="text"
                style="height: 103px"
                :disabled="!editMode"
                maxlength="200"
              />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col" style="max-width: 1000px">
              <h5 class="mt-3">Auftrag</h5>
              <hr class="mt-0" />
            </div>
          </div>
          <div class="row" style="max-width: 1000px">
            <div class="col">
              <label class="text-muted d-block mb-1"><small>Auftragshöhe</small></label>
              <b-input-group
                prepend="€"
                :disabled="record.Status !== '0' || !editMode"
                :readonly="record.Status !== '0'"
              >
                <b-input
                  v-model="record.AHoehe"
                  @update="
                    recordFormChanged = true;
                    takeOverAHoehe();
                  "
                  type="number"
                  step="0.01"
                  :disabled="record.Status !== '0' || !editMode"
                  :readonly="record.Status !== '0'"
                  ref="AHoehe"
                  @input="$refs['AHoehe'].setCustomValidity('')"
                  lazy
                />
              </b-input-group>
            </div>
            <div class="col">
              <label class="text-muted d-block mb-1"><small>Auftragsdatum</small></label>
              <b-input
                lazy
                v-model="record.ADate"
                @change="
                  recordFormChanged = true;
                  takeOverAHoehe();
                "
                type="date"
                :required="evalADateRequired()"
                :disabled="record.Status !== '0' || !editMode"
                :readonly="record.Status !== '0'"
              />
            </div>
            <div class="col">
              <label class="text-muted d-block mb-1"><small>Auftragstext</small></label>
              <b-input
                v-model="record.AText"
                @keyup="onFormFieldKeyUp"
                :disabled="record.Status !== '0' || !editMode"
                :readonly="record.Status !== '0'"
              />
            </div>
          </div>
        </b-form>
        <br />
        <br />
        <br />
        <br />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
//import AllocationUnitsService from '@/service/AllocationUnitsService';
//import ProjectStore from '@/store/Projects';
import SettingsStore from '@/store/Settings';
import OrdersService from '@/service/OrdersService.js';

export default {
  async activated() {
    this.editMode = this.$route.params && typeof this.$route.params.aid === 'undefined';
    this.isLoading = true;
    if (this.$route.params.aid) {
      await this.loadAddendum();
    } else {
      this.record = {
        Nr: null,
        Inhalt: null,
        NDate: null,
        EDate: null,
        PDate: null,
        Status: '0',
        Comment: null,
        StatusDate: null
      };
      this.isLoading = false;
    }
    this.recordFormChanged = false;
    AppState.isLoading = false;
  },
  data() {
    return {
      editMode: false,
      SettingsStore,
      record: {
        Nr: null,
        Inhalt: null,
        NDate: null,
        EDate: null,
        PDate: null,
        Status: '0',
        Comment: null
      },
      recordFormChanged: false,
      isLoading: true
    };
  },
  methods: {
    onFormFieldKeyUp(key) {
      if (
        key.which == 9 ||
        key.which == 13 ||
        key.which == 16 ||
        key.which == 27 ||
        key.which == 32 ||
        key.which == 35 ||
        key.which == 36 ||
        key.which == 37 ||
        key.which == 39
      )
        return;

      this.recordFormChanged = true;
    },
    evalADateRequired() {
      if (!this.record) return false;
      if (!this.record.AHoehe) return false;
      if (this.record.AHoehe == '') return false;
      return true;
    },
    takeOverAHoehe() {
      if (!this.record.NHoeheChecked || this.record.NHoeheChecked == '') {
        if (this.record.AHoehe && parseFloat(this.record.AHoehe) != 0) {
          this.record.NHoeheChecked = parseFloat(this.record.AHoehe);
        }
      }
      if (!this.record.NHoehe || this.record.NHoehe == '') {
        if (this.record.NHoeheChecked && parseFloat(this.record.NHoeheChecked) != 0) {
          this.record.NHoehe = parseFloat(this.record.NHoeheChecked);
        }
      }
      if (!this.record.PDate || this.record.PDate == '') {
        if (this.record.ADate && this.record.ADate != '')
          this.record.PDate = JSON.parse(JSON.stringify(this.record.ADate));
      }
      if (!this.record.NDate || this.record.NDate == '') {
        if (this.record.PDate && this.record.PDate != '')
          this.record.NDate = JSON.parse(JSON.stringify(this.record.PDate));
      }
      if (!this.record.EDate || this.record.EDate == '') {
        if (this.record.PDate && this.record.PDate != '')
          this.record.EDate = JSON.parse(JSON.stringify(this.record.PDate));
      }
      return this.$forceUpdate();
    },
    onCheckBoxAbgelehntChange() {
      this.recordFormChanged = true;
      if (this.record.Status !== '0') {
        this.record.NHoeheChecked = '0.00';
        this.record.AHoehe = '0.00';
      }
    },
    async loadAddendum() {
      OrdersService.getAddendumById(this.$route.params.id, this.$route.params.aid)
        .then(async record => {
          record.NDate = this.$utils.SQLDateToBrowserDate(record.NDate);
          record.EDate = this.$utils.SQLDateToBrowserDate(record.EDate);
          record.PDate = this.$utils.SQLDateToBrowserDate(record.PDate);
          record.ADate = this.$utils.SQLDateToBrowserDate(record.ADate);
          //record.NHoehe = parseFloat(record.NHoehe);
          //record.AHoehe = parseFloat(record.AHoehe);
          this.record = record;

          await this.$forceUpdate();
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        })
        .finally(() => {
          setTimeout(() => {
            this.isLoading = false;
          }, 100);
        });
    },
    async saveRecordAndReturn() {
      this.takeOverAHoehe();
      if (this.record.AHoehe == null || this.record.AHoehe == '') this.record.ADate = null;
      await this.$forceUpdate();
      const input = this.$refs['AHoehe'];
      input.setCustomValidity(''); // remove current displayed notification
      if (
        this.record.Status == '0' &&
        this.record.AHoehe &&
        this.record.AHoehe !== '' &&
        parseFloat(this.record.AHoehe) == 0
      ) {
        input.setCustomValidity('Auftrag darf nicht 0 sein');
        return input.reportValidity();
      }

      if (!this.$refs.recordForm.checkValidity()) {
        return this.$refs.recordForm.reportValidity();
      }

      this.isLoading = true;
      if (this.$route.params.aid) {
        OrdersService.updateAddendum(this.record)
          .then(() => {
            this.$showSuccess(this, 'Nachtrag bearbeiten', 'Nachtrag erfolgreich gespeichert.');
            this.$router.replace('/orders/' + this.$route.params.id + '/addendums');
            this.$eventBus.$emit('update:nachtrag');
          })
          .catch(err => {
            if (err.response) {
              this.$bvModal.msgBoxOk(err.response.data.error, {
                title: 'Nachtrag speichern',
                okTitle: 'Ok',
                okVariant: 'danger',

                centered: true
              });
            } else this.$showError(this, err.toString());
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.record.OrderId = this.$route.params.id;
        OrdersService.createAddendum(this.record)
          .then(() => {
            this.$showSuccess(this, 'Nachtrag erstellen', 'Nachtrag erfolgreich gespeichert.');
            //this.$router.replace(this.$route.path.replace('/create', ''));
            this.$router.replace({ name: 'Nachträge', replace: true });
            //this.$router.replace({ path: '/orders/' + this.$route.params.id + '/addendums' });
            this.$eventBus.$emit('update:nachtrag');
          })
          .catch(err => {
            if (err.response) this.$showError(this, err.response.data.error);
            else this.$showError(this, err.toString());
          })
          .finally(() => (this.isLoading = false));
      }
    }
  }
};
</script>
